import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SmileyFacesIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "8.7",
    cy: "12",
    r: "7.7"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.77,11a1,1,0,1,0-1,1A1,1,0,0,0,6.77,11Z",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "11.59",
    cy: "11.04",
    r: "0.96",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5.81,14.41a6.14,6.14,0,0,0,2.89,1,6.14,6.14,0,0,0,2.89-1",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.02"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19.15,12a3.77,3.77,0,0,0-1.67.4,8.69,8.69,0,0,1-1.85,5A3.85,3.85,0,1,0,19.15,12Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.19,15.37a.48.48,0,0,0-.48-.48.47.47,0,0,0-.48.48.48.48,0,0,0,.48.48A.49.49,0,0,0,18.19,15.37Z",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "20.59",
    cy: "15.37",
    r: "0.48",
    fill: "#fff"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.71,17.53a3,3,0,0,1,1.44-.48,3,3,0,0,1,1.44.48",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.51"
  })]
}), 'SmileyFacesIcon');